import createPersistedState from 'vuex-persistedstate';
import { Plugin } from 'vuex';
import RootState from '@/store/RootState';
import VuexORM from '@vuex-orm/core';
import database from '@/store/database';
import VuexORMSearch from '@vuex-orm/plugin-search';

VuexORM.use(VuexORMSearch, {
    caseSensitive: false,
});

const plugins: Array<Plugin<RootState>> = [
    VuexORM.install(database),
    createPersistedState({
        key: 'uva',
        paths: [
            'entities',
        ],
    }),
];

export default plugins;
